// app/javascript/compcalc/components/App.jsx

import React from "react";
import PropTypes from "prop-types";
import { Link, /*withRouter, */Navigate } from 'react-router-dom';
import { withRouter } from './utils/WithRouter';
import { withStyles } from '@material-ui/core/styles';

import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from "@material-ui/core";

import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Menu from '@material-ui/core/Menu';
import SvgIcon from '@material-ui/core/SvgIcon';
import Toolbar from '@material-ui/core/Toolbar';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';

import Divider from '@material-ui/core/Divider';

import MenuIcon from '@material-ui/icons/Menu';
import FileIcon from '@material-ui/icons/Save';
import HomeIcon from '@material-ui/icons/Home';
import EditIcon from '@material-ui/icons/Edit';
import ViewIcon from '@material-ui/icons/ViewList';
import HelpIcon from '@material-ui/icons/Help';

import { CopyToClipboard } from 'react-copy-to-clipboard';
import { SnackbarProvider } from 'notistack';
import { pdf } from '@react-pdf/renderer';
import { PdfDocument } from './pdf/PdfDocument';


require('./Config.js');
const TitleImage = require(global.config.isAIG ? './images/aig.png' : 
                       global.config.isCAAA ? './images/caaa.png' : 
                       global.config.isCompCalc ? './images/title.png' : 
                       global.config.isNational ? './images/ndi.png' : 
                       './images/matrix.png');
const PoweredImage = require('./images/powered.png');
const UnderConstructionImage = require('./images/under-construction.png');

import { saveAsFile, getParameterByName, formatLongDate } from '../utils';

import AppDrawer from './AppDrawer';


const styles = theme => ({
  root: {
    padding: theme.spacing(1),
  },
  title: {
    marginTop: theme.spacing(1),
  },
  dismissButton: {
    color: '#FFFFFF',
  }
});


function AppleIcon(props) {
  return (
    <SvgIcon viewBox="0 0 30 30" {...props}>
      <path d="M25.565 9.785c-.123.077-3.051 1.702-3.051 5.305.138 4.109 3.695 5.55 3.756 5.55-.061.077-.537 1.963-1.947 3.94-1.119 1.703-2.361 3.42-4.247 3.42-1.794 0-2.438-1.135-4.508-1.135-2.223 0-2.852 1.135-4.554 1.135-1.886 0-3.22-1.809-4.4-3.496-1.533-2.208-2.836-5.673-2.882-9-.031-1.763.307-3.496 1.165-4.968 1.211-2.055 3.373-3.45 5.734-3.496 1.809-.061 3.419 1.242 4.523 1.242 1.058 0 3.036-1.242 5.274-1.242.966.001 3.542.292 5.137 2.745zM15.001 6.688c-.322-1.61.567-3.22 1.395-4.247 1.058-1.242 2.729-2.085 4.17-2.085.092 1.61-.491 3.189-1.533 4.339-.935 1.242-2.545 2.177-4.032 1.993z" />
    </SvgIcon>
  );
}


function WindowsIcon(props) {
  return (
    <SvgIcon viewBox="0 0 50 50" {...props}>
      <path d="M46 4.867188l-21 2.625V24h21zm-23 2.875l-19 2.375V24h19zM4 26v13.882813l19 2.375V26zm21 0v16.507813l21 2.625V26z" />
    </SvgIcon>
  );
}


class App extends React.PureComponent {

  constructor(props) {
    super(props);

    this.components = {}; // Components cache refs.
    this.componentNames = [
      "Permanent Disability Rating Manual / Schedule",
      // "PD / TD Earnings Calculator",
      "Permanent Disability Indemnity",
      "SAWW Percentage Increases & Temporary Total Disability",
      "Commutation of Attorney's Fees",
      "Life Pension Weekly Payment",
      "Future Value / Present Value / COLA Calculator",
      "Life Expectancy",
      "Supplemental Job Displacement Benefit Voucher",
      "Death Benefits",
      "Date Calculator",
      "Qualified Medical Evaluators Codes / Body Part Codes",
      "Combined Value Equation",
      "Support & Training",
      "About Workers' Compensation Indemnity Calculator",
    ];
    this.links = [
      "/pdr",
      // "/wage",
      "/pd",
      "/td",
      "/comm",
      "/lp",
      "/pv",
      "/le",
      "/jd",
      "/db",
      "/date",
      "/qme",
      "/cve",
      "/support",
      "/about",
    ];

    this.menuHandler = this.props.menuHandler;
    this.pdfData = { left: '', right: '', center: '' };

    // Check the current URL, and set up drawerIndex accordingly.
    let drawerIndex = this.links.indexOf(props.location.pathname);
    if (drawerIndex == -1)
      drawerIndex = 0;

    this.state = {
      isDrawerOpen: false,
      isPrintDialogOpen: false,
      drawerIndex: drawerIndex,
      menuFileAnchorElement: null,
      menuEditAnchorElement: null,
      menuViewAnchorElement: null,
      menuHelpAnchorElement: null,
      flipTables: true,
      applicant: '',
      physician: '',
      caseNumber: '',
      reportDate: formatLongDate(new Date()),
    };
  };

  getChildContext = () => {
    return {
      // muiTheme: ThemeManager.getCurrentTheme()
    };
  };

  // --------------------- Drawer related ---------------------
  drawerIndexChanged = (itemIndex) => {
    // console.log("App.drawerIndexChanged(), index", itemIndex);
    this.props.copyToClipboard('');
    this.setState({ drawerIndex: itemIndex });
  };

  toggleDrawer = (isOpen) => {
    this.setState({ isDrawerOpen: isOpen });
  };

  // --------------------- Menu opening ---------------------
  handleOpenMenu = (event, key) => {
    this.setState({
      menuFileAnchorElement: null,
      menuEditAnchorElement: null,
      menuViewAnchorElement: null,
      menuHelpAnchorElement: null,
      [key]: event.currentTarget,
    });
  };

  handleMenuClose = (afterFunc) => {
    this.setState({
      menuFileAnchorElement: null,
      menuEditAnchorElement: null,
      menuViewAnchorElement: null,
      menuHelpAnchorElement: null,
    }, afterFunc);
  };

  // --------------------- Menu selection ---------------------
  handleMenuSave = () => {
    this.handleMenuClose(() => this.menuHandler('file', 'save'));
  };

  handleMenuLoad = () => {
    this.handleMenuClose(() => this.menuHandler('file', 'load'));
  };

  handleMenuPdf = () => {
    this.handleMenuClose(() => {
      this.setState({ isPrintDialogOpen: true });
    });
  };

  generatePdf = async () => {
    this.menuHandler('file', 'pdf');
    const blob = await pdf(
      (
        <PdfDocument
          title='PD Ratings'
          data={ this.pdfData }
        />
      )
    ).toBlob();
    saveAsFile('PD-Ratings.pdf', blob);
  };

  handleMenuMail = () => {
    this.handleMenuClose(() => this.menuHandler('file', 'mail'));
  };

  handleMenuAdd = () => {
    this.handleMenuClose(() => this.menuHandler('edit', 'add'));
  };

  handleMenuDelete = () => {
    this.handleMenuClose(() => this.menuHandler('edit', 'delete'));
  };

  handleMenuClear = () => {
    this.handleMenuClose(() => this.menuHandler('edit', 'clear'));
  }

  handleMenuCopyRating = () => {
    this.handleMenuClose(() => this.menuHandler('edit', 'copy_rating'));
  }

  handleMenuCopy = () => {
    this.handleMenuClose(() => this.menuHandler('edit', 'copy'));
  }

  handleMenuPaste = () => {
    this.handleMenuClose(() => this.menuHandler('edit', 'paste'));
  }

  handleMenuFlipTables = () => {
    let flip = !this.state.flipTables;
    // console.log(`handleMenuFlipTables(${flip})`);
    this.setState({
      menuFileAnchorElement: null,
      menuEditAnchorElement: null,
      menuViewAnchorElement: null,
      menuHelpAnchorElement: null,
      flipTables: flip,
    }, () => this.menuHandler('view', 'flip_tables', this.state.flipTables));
  }

  handleMenuSwitchGroups = () => {
    this.handleMenuClose(() => this.menuHandler('view', 'switch_occ_groups'));
  }

  handleMenuGetMacVersion = () => {
    window.open('https://itunes.apple.com/us/app/compcalc-plus-2019/id1332232796', '_blank');
    this.handleMenuClose();
  }

  handleMenuGetWindowsVersion = () => {
    window.open('https://apps.microsoft.com/store/detail/compcalc-plus-2022/9PG4SXPHX119', '_blank');
    this.handleMenuClose();
  }

  handleMenuHome = () => {
    window.open(global.config.isAIG ? 'https://www.aig.com/' :
                global.config.isCAAA ? 'https://www.caaa.org/' :
                global.config.isCompCalc ? 'https://www.montarbolaw.com/' :
                'https://legal-records.us/', '_self');
    this.handleMenuClose();
  }

  handleMenuHelpBasics = () => {
    window.open('https://www.youtube.com/watch?v=LMwoTHwZqfQ', '_blank');
    this.handleMenuClose();
  }

  handleMenuHelpRating = () => {
    window.open('https://www.youtube.com/watch?v=WoIoFM6Cf0g', '_blank');
    this.handleMenuClose();
  }

  handleMenuHelpAdvanced = () => {
    window.open('https://www.youtube.com/watch?v=W_Q08jq5kKk', '_blank');
    this.handleMenuClose();
  }

  handleMenuHelpContact = () => {
    window.open(global.config.isAIG ? 'https://www.aig.com/about-us/contact-us' : 
                global.config.isCAAA ? 'https://www.caaa.org/index.cfm?pg=About-Us' : 
                global.config.isCompCalc ? 'https://www.montarbolaw.com/contact-us' : 
                'https://legal-records.us/about-us', '_blank');
    this.handleMenuClose();
  }

  handleMenuSupport = () => {
    this.handleMenuClose(() => this.drawerIndexChanged(12));
  }

  handleMenuAbout = () => {
    this.handleMenuClose(() => {
      if (global.config.isCompCalc || global.config.isCAAA || global.config.isAIG) {
        this.drawerIndexChanged(13);
      }
      else {
        window.open('https://legal-records.us/about-us', '_blank');
      }
    });
  }

  onMenuClose = () => {
    this.handleMenuClose(undefined);
  }

  // ------------------- Print dialog --------------------
  onPrintDialogClose = () => {
    this.setState({ isPrintDialogOpen: false });
  }

  onPrintDialogGenerate = () => {
    this.setState({ isPrintDialogOpen: false }, () => {
      (async() => {
        console.log('1')
        await this.generatePdf()  
        console.log('2')
      })()
    });
  }

  // --------------------- Rendering ---------------------
  render() {
    // console.log("App.render(), index", this.state.drawerIndex);

    if (this.props.location.pathname != this.links[this.state.drawerIndex]) {
      // console.log(`Current: ${this.props.location.pathname}, need: ${this.links[this.state.drawerIndex]}`)
      // this.props.history.push(this.links[this.state.drawerIndex]); return null;
      return (<Navigate to={ this.links[this.state.drawerIndex] } replace />);
    }

    const { classes } = this.props;

    let menuFileAnchorElement = this.state.menuFileAnchorElement;
    let menuEditAnchorElement = this.state.menuEditAnchorElement;
    let menuViewAnchorElement = this.state.menuViewAnchorElement;
    let menuHelpAnchorElement = this.state.menuHelpAnchorElement;

    let isPd = this.state.drawerIndex === 0;
    let isTd = this.state.drawerIndex === 2;
    let isPv = this.state.drawerIndex === 3 || this.state.drawerIndex === 5; // Comm and PV/Cola has the same menu.
    let isCve = this.state.drawerIndex === 11;

    let isPdCve = isPd || isCve;
    let isTdPdPv = isTd || isPd || isPv;
    let isTdPdCve = isTd || isPdCve;
    let isTdPdPvCve = isTd || isPd || isPv || isCve;

    let isUnderConstruction = false;//this.state.drawerIndex == 3;
    // const HomeLink = props => <Link to="http://www.montarbolaw.com" {...props} />

    let iconColor = 
      global.config.isCompCalc || global.config.isAIG || global.config.isCAAA ? '##ffffff' :
      global.config.isNational ? '#a71d1e' :
      '#e9bf1d' // Matrix

    return (
      <div className={classes.root}>
        <SnackbarProvider maxSnack={4} action={[ <Button classes={{ root: classes.dismissButton }} size="small">{'Dismiss'}</Button> ]}>
          <React.Fragment>
            {/* Material App Drawer */}
            <AppDrawer
              isDrawerOpen={ this.state.isDrawerOpen }
              toggleDrawer={ isOpen => this.toggleDrawer(isOpen) }
              drawerIndex={ this.state.drawerIndex }
              drawerIndexChanged={ this.drawerIndexChanged } />

            {/* Material App Bar */}
            <AppBar position="static" color={ global.config.isNational ? "secondary" : "primary" } >
              <Toolbar>
                {/* Drawer toggle button. */}
                <Tooltip title="Navigate" aria-label="Navigate">
                  <IconButton style={{ color: iconColor }} onClick={ () => this.toggleDrawer(true) }>
                    <MenuIcon />
                  </IconButton>
                </Tooltip>

                {/* Title. */}
                <div style={{ marginLeft: 32, display: 'flex', flex: 1, justifyContent: 'flex-start', alignItems: 'center' }}>
                  { isUnderConstruction
                    && <img style={{ height: '94px' }} src={ UnderConstructionImage } alt="under construction"/>
                    || <img style={{ height: '94px' }} src={ TitleImage } alt="Title image" onClick={this.home} /> }
                </div>
                {/* <Typography variant="h6" color="inherit" style={{ flex: 1 }}>
                      `CompCalc Plus 2024: ${this.componentNames[this.state.drawerIndex]}`
                    </Typography> */}

                {/* Right menu icons. */}
                <Tooltip title="Home" aria-label="Home">
                  <IconButton style={{ marginRight: 32, color: iconColor }} onClick={ e => this.handleMenuHome() }>
                    <HomeIcon/>
                  </IconButton>
                </Tooltip>

                <Tooltip title="Get Apple's OS X version" aria-label="MacOS">
                  <IconButton style={{ color: iconColor }} onClick={ e => this.handleMenuGetMacVersion() }>
                    <AppleIcon/>
                  </IconButton>
                </Tooltip>

                <Tooltip title="Get Windows 10 version" aria-label="Windows">
                  <IconButton style={{ marginRight: 32, color: iconColor }} onClick={ e => this.handleMenuGetWindowsVersion() }>
                    <WindowsIcon/>
                  </IconButton>
                </Tooltip>

                <Tooltip title="File" aria-label="File">
                  <IconButton
                    aria-owns={ menuFileAnchorElement ? 'menuFile' : null }
                    aria-haspopup="true"
                    style={{ color: iconColor }} 
                    onClick={ event => this.handleOpenMenu(event, 'menuFileAnchorElement') }
                  >
                    <FileIcon/>
                  </IconButton>
                </Tooltip>

                <Tooltip title="Edit" aria-label="Edit">
                  <IconButton
                    aria-owns={ menuEditAnchorElement ? 'menuEdit' : null }
                    aria-haspopup="true"
                    style={{ color: iconColor }} 
                    onClick={ event => this.handleOpenMenu(event, 'menuEditAnchorElement') }
                  >
                    <EditIcon/>
                  </IconButton>
                </Tooltip>

                <Tooltip title="View" aria-label="View">
                  <IconButton
                    aria-owns={ menuViewAnchorElement ? 'menuView' : null }
                    aria-haspopup="true"
                    style={{ color: iconColor }} 
                    onClick={ event => this.handleOpenMenu(event, 'menuViewAnchorElement') }
                  >
                    <ViewIcon/>
                  </IconButton>
                </Tooltip>

                <Tooltip title="Help" aria-label="Help">
                  <IconButton
                    aria-owns={ menuHelpAnchorElement ? 'menuHelp' : null }
                    aria-haspopup="true"
                    style={{ color: iconColor }} 
                    onClick={ event => this.handleOpenMenu(event, 'menuHelpAnchorElement') }
                  >
                    <HelpIcon/>
                  </IconButton>
                </Tooltip>

                <Menu
                  id="menuFile"
                  anchorEl={ menuFileAnchorElement }
                  open={ Boolean(menuFileAnchorElement) }
                  onClose={this.onMenuClose}
                >
                  <ListItem selected={false} button disabled={!isTdPdPv} onClick={this.handleMenuSave}>Save to file</ListItem>
                  <ListItem button disabled={!isTdPdPv} onClick={this.handleMenuLoad}>Load from file</ListItem>
                  <Divider/>
                  {/* { <ListItem button disabled={!isTdPdPv} onClick={this.handleMenuPdf}>Save to PDF</ListItem> } */}
                  {/* { <PDFDownloadLink document={<PdfDocument data={this.props.pdfData}/>} fileName="PD Ratings.pdf">
                  </PDFDownloadLink> } */}

                  <ListItem button disabled={!isTdPdPv} onClick={this.handleMenuMail}>Send by e-mail</ListItem>
                  <Divider/>
                  <CopyToClipboard text={ this.props.clipboard }>
                    <div>
                      <ListItem button disabled={!isTdPdPv} onClick={this.handleMenuCopy}>Copy (paste to e-mail or Word)</ListItem>
                    </div>
                  </CopyToClipboard>
                  {/* <Divider/> */}
                </Menu>

                <Menu
                  id="menuEdit"
                  anchorEl={ menuEditAnchorElement }
                  open={ Boolean(menuEditAnchorElement) }
                  onClose={this.onMenuClose}
                >
                  {isPdCve && <ListItem selected={false} button onClick={this.handleMenuAdd}>{isPd ? 'New rating string' : 'New Number'}</ListItem>}
                  {isPdCve && <Divider/> }
                  {isPdCve && <ListItem button onClick={this.handleMenuDelete}>{isPd ? 'Delete selected rating' : 'Delete selected number'}</ListItem>}
                  {isTdPdPvCve && <ListItem button onClick={this.handleMenuClear}>Clear all the inputs</ListItem>}
                  {isTdPdPvCve && <Divider/>}
                  <CopyToClipboard text={ this.props.clipboard }>
                    <div>
                      <ListItem button disabled={!isTdPdPv} onClick={this.handleMenuCopy}>Copy (paste to e-mail or word)</ListItem>
                    </div>
                  </CopyToClipboard>
                  {isTdPdPvCve && <Divider/>}
                  {isPdCve && <ListItem button onClick={this.handleMenuCopyRating}>{isCve ? 'Copy selected number' : 'Copy selected rating'}</ListItem>}
                  <ListItem button disabled={!isPdCve} onClick={this.handleMenuPaste}>{isCve ? 'Paste number' : 'Paste rating'}</ListItem>
                </Menu>

                <Menu
                  id="menuView"
                  anchorEl={ menuViewAnchorElement }
                  open={ Boolean(menuViewAnchorElement) }
                  onClose={this.onMenuClose}
                >
                  <ListItem selected={false} button disabled={ !isPd } onClick={ this.handleMenuFlipTables }>
                    Flip tables
                    <ListItemSecondaryAction>
                      <Checkbox disabled={ !isPd } checked={ this.state.flipTables } onChange={ this.handleMenuFlipTables } color="primary" />
                    </ListItemSecondaryAction>
                  </ListItem>
                  <ListItem button disabled={!isPd} onClick={this.handleMenuSwitchGroups}>Show occupations / groups</ListItem>
                  {/*<ListItem button disabled={!isPd} onClick={this.handleMenuFlip}>Flip Tables</ListItem> */}
                </Menu>

                <Menu
                  id="menuHelp"
                  anchorEl={ menuHelpAnchorElement }
                  open={ Boolean(menuHelpAnchorElement) }
                  onClose={this.onMenuClose}
                >
                  <ListItem selected={false} button onClick={this.handleMenuHome}>Home page</ListItem>
                  <ListItem button onClick={this.handleMenuSupport}>Support & Training</ListItem>
                  {/*<ListItem button onClick={this.handleMenuHelpBasics}>Basic Features & Functions</ListItem>
                  <Divider/>
                  <ListItem button onClick={this.handleMenuHelpRating}>Rating with CompCalc Plus</ListItem>
                  <ListItem button onClick={this.handleMenuHelpAdvanced}>Advanced Tips & Techniques</ListItem>*/}
                  { (global.config.isCAAA || global.config.isAIG) &&
                    <ListItem button onClick={this.handleMenuAbout}>About this program</ListItem>
                  }
                  { !global.config.isCAAA && !global.config.isAIG &&
                    <ListItem button onClick={this.handleMenuAbout}>About us</ListItem>
                  }
                  <ListItem button onClick={this.handleMenuHelpContact}>Contact us</ListItem>
                </Menu>
              </Toolbar>
            </AppBar>

            <Typography className={classes.title} variant="h4" align="center" >
              {this.componentNames[this.state.drawerIndex]}
            </Typography>

            { // Main content.
              this.props.children
            }

            { (global.config.isAIG || global.config.isCAAA) &&
              <div style={{ margin: '24px', display: 'flex', flex: 1, justifyContent: 'flex-end' }}>
                <img src={ PoweredImage } alt="powered by CompCalc Plus 2024"/>
              </div>
            }
          </React.Fragment>
          <Dialog open={ this.state.isPrintDialogOpen } onClose={ this.handlePrintDialogClose }>
            <DialogTitle>Generate PDF</DialogTitle>
            <DialogContent>
              <DialogContentText>Please fill in all the needed fields.</DialogContentText>
              <TextField
                autoFocus
                margin="dense"
                id="name"
                label="Applicant's name"
                type="name"
                fullWidth
                variant="standard"
                value={ this.state.applicant }
                onKeyPress={ e => e.key == 'Enter' && e.target.blur() }
                onChange={ (e) => this.setState({ applicant: e.target.value }) }
                onFocus={ (e) => e.target.select() }
              />
              <TextField
                autoFocus
                margin="dense"
                id="name"
                label="Reporting physician"
                type="name"
                fullWidth
                variant="standard"
                value={ this.state.physician }
                onKeyPress={ e => e.key == 'Enter' && e.target.blur() }
                onChange={ (e) => this.setState({ physician: e.target.value }) }
                onFocus={ (e) => e.target.select() }
              />
              <TextField
                autoFocus
                margin="dense"
                id="name"
                label="Case number"
                type="email"
                fullWidth
                variant="standard"
                value={ this.state.caseNumber }
                onKeyPress={ e => e.key == 'Enter' && e.target.blur() }
                onChange={ (e) => this.setState({ caseNumber: e.target.value }) }
                onFocus={ (e) => e.target.select() }
              />
              <TextField
                autoFocus
                margin="dense"
                id="name"
                label="Date of report"
                type="email"
                fullWidth
                variant="standard"
                value={ this.state.reportDate }
                onKeyPress={ e => e.key == 'Enter' && e.target.blur() }
                onChange={ (e) => this.setState({ reportDate: e.target.value }) }
                onFocus={ (e) => e.target.select() }
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={ this.onPrintDialogClose }>Cancel</Button>
              <Button onClick={ this.onPrintDialogGenerate}>Generate</Button>
            </DialogActions>
          </Dialog>
        </SnackbarProvider>
      </div>
    );
  }

}

App.childContextTypes = {

};

App.propTypes = {
  classes: PropTypes.object.isRequired,
  copyToClipboard: PropTypes.func.isRequired
};

export default withRouter(withStyles(styles)(App));
